import styled from 'styled-components';
import { changeColorAlpha } from '@elfsight/lib-utils';
import { Loader } from '@elfsight/widget-ui';
import { getHandleActionKeyDown } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { classnamePrefix } from '../../../constants';
import { dictionary } from '../../dictionary';

export const LoadMore = ({
  onClick = () => {},
  text = 'Load More',
  loading = false
}) => {
  const { textColor, lang } = useSettings();
  const localizedMessage = dictionary[lang]?.[text] || dictionary.en[text];

  return (
    <Component
      onClick={onClick}
      role="button"
      tabIndex="0"
      onKeyDown={getHandleActionKeyDown(onClick)}
      _textColor={textColor}
    >
      {loading ? (
        <Loader
          color={textColor}
          size={16}
          className={`${classnamePrefix}-spinner-component`}
        />
      ) : (
        localizedMessage
      )}
    </Component>
  );
};

const Component = styled.div.attrs({
  className: `${classnamePrefix}-load-more-component`
})`
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  display: inline-flex;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
  border-radius: 4px;
  position: relative;
  max-width: 500px;
  width: 100%;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  color: ${({ _textColor }) =>
    _textColor ? changeColorAlpha(_textColor, -0.5) : 'rgba(26, 46, 59, 0.5)'};
  background-color: ${({ _textColor }) =>
    _textColor
      ? changeColorAlpha(_textColor, -0.94)
      : 'rgba(26, 46, 59, 0.06)'};

  &:hover {
    background-color: ${({ _textColor }) =>
      _textColor ? changeColorAlpha(_textColor, -0.9) : '#ebebeb'};
  }
`;
